module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-xs-12 block versiculo__des"
  }, [_c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("VERSICULO DEL DIA")]), _vm._v(" "), (_vm.versiculo.better_featured_image != null) ? _c('img', {
    attrs: {
      "src": _vm.versiculo.better_featured_image.source_url
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.versiculo.soloexcerpt))]), _vm._v(" "), _c('p', {
    staticClass: "cita"
  }, [_vm._v(_vm._s(_vm.versiculo.title.rendered))]), _vm._v(" "), _c('div', {
    staticClass: "compartir"
  }, [_c('span', [_vm._v("Compartir en")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + _vm.versiculo.link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/share?text=' + _vm.versiculo.title.rendered,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "itemwa"
  }, [_c('a', {
    attrs: {
      "href": 'whatsapp://send?text=' + _vm.versiculo.soloexcerpt + ' ' + _vm.versiculo.title.rendered + ' ' + _vm.versiculo.link
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "versiculo__descargar",
    attrs: {
      "href": _vm.versiculo.better_featured_image.source_url
    }
  }, [_vm._v("DESCARGAR")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddd32da8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/interna_versiculo.vue
// module id = 148
// module chunks = 0